// @flow
import React from "react";
import artLogo from "./../images/teamlogos/art.png";
import btvLogo from "./../images/teamlogos/btv.png";
import bwaLogo from "./../images/teamlogos/bwa.jpeg";
import dtvLogo from "./../images/teamlogos/dtv.png";
import fcjLogo from "./../images/teamlogos/fcj.png";
import mindenLogo from "./../images/teamlogos/minden.png";
import ptsvLogo from "./../images/teamlogos/ptsv.svg";
import saxLogo from "./../images/teamlogos/sax-logo.png";
import sgcoeLogo from "./../images/teamlogos/sgcoe.svg";
import slcbhLogo from "./../images/teamlogos/slcbh.png";
import solingenLogo from "./../images/teamlogos/solingen.svg";
import ssfbonnLogo from "./../images/teamlogos/ssfbonn.png";
import tpbLogo from "./../images/teamlogos/tpb.svg";
import tscLogo from "./../images/teamlogos/tsc.jpg";
import tscedLogo from "./../images/teamlogos/tsced.png";
import tsvgwLogo from "./../images/teamlogos/tsvgw.png";
import tvaLogo from "./../images/teamlogos/tva.jpg";
import tvhoerdeLogo from "./../images/teamlogos/tvhoerde.png";
import uscLogo from "./../images/teamlogos/usc.png";
import vcrekenLogo from "./../images/teamlogos/vcreken.png";
import vvhLogo from "./../images/teamlogos/vvh.png";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

type Props = {
  iconString: any,
  name: string,
  width?: number,
  height?: number,
};

const ICON_MAP = {
  "art.png": artLogo,
  "btv.png": btvLogo,
  "bwa.jpeg": bwaLogo,
  "dtv.png": dtvLogo,
  "fcj.png": fcjLogo,
  "minden.png": mindenLogo,
  "ptsv.svg": ptsvLogo,
  "sax-logo.png": saxLogo,
  "sgcoe.svg": sgcoeLogo,
  "slcbh.png": slcbhLogo,
  "solingen.svg": solingenLogo,
  "ssfbonn.png": ssfbonnLogo,
  "tpb.svg": tpbLogo,
  "tsc.jpg": tscLogo,
  "tsced.png": tscedLogo,
  "tsvgw.png": tsvgwLogo,
  "tva.jpg": tvaLogo,
  "tvhoerde.png": tvhoerdeLogo,
  "usc.png": uscLogo,
  "vcreken.png": vcrekenLogo,
  "vvh.png": vvhLogo,
};

const useStyles = makeStyles({
  fallbackWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  avatar: {
    width: 50,
    height: 50,
    marginLeft: "auto",
    marginRight: "auto",
  },
  image: {
    maxWidth: "100%",
    objectFit: "contain",
    marginLeft: "auto",
    marginRight: "auto",
    display: "block",
  },
});

function TeamLogo({ iconString, name, width = 50, height = 60 }: Props) {
  const classes = useStyles();

  if (iconString == null || ICON_MAP[iconString] == null) {
    return (
      <Box className={classes.fallbackWrapper}>
        <Avatar
          className={classes.avatar}
          style={{ width, height, maxWidth: height, maxHeight: width }}
        >
          {name != null && name.substr(0, 2).toUpperCase()}
        </Avatar>
      </Box>
    );
  }
  return (
    <img
      src={ICON_MAP[iconString]}
      alt={`${name} Logo`}
      className={classes.image}
      style={{
        width,
        height,
      }}
    />
  );
}

export default TeamLogo;
